module.exports = __webpack_public_path__ + "audio-b02256d96184.m4a";